/* ============
 * Main File
 * ============
 *
 * Will initialize the application.
 */

import Vue from 'vue';

/* ============
 * Plugins
 * ============
 *
 * Import the plugins.
 */

import './plugins/vuex';
import './plugins/axios';
import { i18n } from './plugins/vue-i18n';
import { router } from './plugins/vue-router';
import './plugins/vuex-router-sync';
import './plugins/font-awesome';

/* ============
 * Styling
 * ============
 *
 * Import the application styling.
 */
import './assets/app.scss';

/* ============
 * Main App
 * ============
 *
 * Import the main application.
 */

import App from './App.vue';
import store from './store';

Vue.config.productionTip = false;

/* eslint-disable no-new */ // <-- this disables a lint error, do not remove
new Vue({
  el: '#app', // Binds the Vue instance to the HTML.
  i18n, // Localization plugin.
  router,
  store,
  render: (h) => h(App), // Renders the application.
});
